import { GLOBLE_OBJECT,GIFT_LIST_HEADER } from './actions';

const initialState = {
  loaded: false,
  ImageFullPath: '',
  CSSFullPath: '',
  giftListHeader : "Mesa de regalos"

};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case GLOBLE_OBJECT: {
      const globleObject = state;
      globleObject.ImageFullPath = 'Image Path';
      globleObject.CSSFullPath = 'CSS Path';
      return {
        globleObject,
      };
    }
    case GIFT_LIST_HEADER :
      return {
        ...state,
        giftListHeader : action.data

      }
    default: {
      return state;
    }
  }
}

export function getGlobleObject() {
  return {
    type: GLOBLE_OBJECT,
  };
}
